module.exports = __webpack_public_path__ + "img/paypal-alternative.fb344c15.png";